/**
 * Tratamento de ponto: lista espelhos EM_TRATAMENTO e permite adicionar ajustes.
 */
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { espApi } from '../../lib/api'
import { PageLoading } from '../../components/LoadingSpinner'
import { formatCpf, formatHoras } from '../../types/api'

export function TratamentoPage() {
  const { data: espelhos, isLoading } = useQuery({
    queryKey: ['espelhos', { status: 'EM_TRATAMENTO' }],
    queryFn: () => espApi.list({ status: 'EM_TRATAMENTO' }),
  })

  const { data: abertos } = useQuery({
    queryKey: ['espelhos', { status: 'ABERTO' }],
    queryFn: () => espApi.list({ status: 'ABERTO' }),
  })

  const pendentes = [...(espelhos ?? []), ...(abertos ?? [])]

  return (
    <div>
      <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, marginBottom: 'var(--space-2)' }}>Tratamento de Ponto</h1>
      <p style={{ color: 'var(--color-gray-600)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--space-6)' }}>
        Abonos, ajustes e justificativas. Toda ação é registrada na trilha de auditoria com hash chain.
        A marcação AFD original nunca é alterada (Portaria 671/2021).
      </p>

      {isLoading ? <PageLoading /> : !pendentes.length ? (
        <div className="card" style={{ textAlign: 'center', padding: 'var(--space-16)' }}>
          <div style={{ fontSize: '3rem', marginBottom: 'var(--space-4)' }}>✓</div>
          <h3 style={{ fontWeight: 600, marginBottom: 'var(--space-2)' }}>Nenhum espelho pendente de tratamento</h3>
          <p style={{ color: 'var(--color-gray-600)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--space-4)' }}>
            Todos os espelhos estão fechados ou não há marcações pendentes.
          </p>
          <Link to="/rh/espelho" className="btn btn-ghost">Ver todos os espelhos</Link>
        </div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>CPF/PIS</th>
                  <th>Data</th>
                  <th>Status</th>
                  <th>Normais</th>
                  <th>Falta</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {pendentes.map(e => (
                  <tr key={e.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 'var(--font-size-xs)' }}>{formatCpf(e.funcionario_cpf_pis)}</td>
                    <td>{new Date(e.data + 'T12:00:00').toLocaleDateString('pt-BR')}</td>
                    <td>
                      <span className={`badge ${e.status === 'EM_TRATAMENTO' ? 'badge-blue' : 'badge-yellow'}`}>
                        {e.status === 'EM_TRATAMENTO' ? 'Em tratamento' : 'Aberto'}
                      </span>
                    </td>
                    <td style={{ color: 'var(--color-success)' }}>{formatHoras(e.horas_normais_s)}</td>
                    <td style={{ color: 'var(--color-danger)' }}>{formatHoras(e.horas_falta_s)}</td>
                    <td>
                      <Link to={`/rh/espelho/${e.id}`} className="btn btn-primary" style={{ fontSize: 'var(--font-size-xs)', padding: 'var(--space-1) var(--space-3)' }}>
                        Tratar →
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}
